// Action creators
import actionTypes from '../constants/actionTypes/calculation-data-action-types';
import { Observable } from 'rxjs';
import gjeFetch from 'gje-fetch';
import endpoint from '../config/endpoint';
import { setGlobalError } from '../actions/error-actions';
import { DEFAULT_ERROR_MSG } from '../constants/errors';

const fetchDataRequest = (param: any, path: string) =>
    gjeFetch
        .postJSON(`/${endpoint}/api/calculation${path}`, param, {
            accept: 'application/json'
        })
        .then(response => response.json());

export const fetchCalculationData = (calculation: any, callback: Function) => ({
    type: actionTypes.REQUEST,
    payload: {
        calculation
    },
    callback
});

export const fetchUpdateCalculationData = (
    calculation: any,
    calculationOut: any,
    callback: Function
) => ({
    type: actionTypes.REQUEST_UPDATE,
    payload: {
        calculation,
        calculationOut
    },
    callback
});

export const fetchBuyCalculationData = (
    calculation: any,
    calculationOut: any,
    callback: Function
) => ({
    type: actionTypes.REQUEST_BUY,
    payload: {
        calculation,
        calculationOut
    },
    callback
});

const fetchCalculationDataSuccess = (payload, callback) => ({
    type: actionTypes.RECEIVE,
    payload,
    callback
});

const fetchCalculationDataError = data => ({
    type: actionTypes.FETCH_ERROR,
    payload: data
});

const epics = [
    {
        action: actionTypes.REQUEST,
        path: '/create'
    },
    {
        action: actionTypes.REQUEST_UPDATE,
        path: '/update'
    },
    {
        action: actionTypes.REQUEST_BUY,
        path: '/buy'
    }
].map(el => action$ =>
    action$.ofType(el.action).mergeMap(action =>
        Observable.from(fetchDataRequest(action.payload, el.path))
            .map(data => fetchCalculationDataSuccess(data, action.callback))
            .catch(handleError)
    )
);

const handleError = error =>
    Observable.concat(
        Observable.fromPromise(
            error
                .json()
                .then(data =>
                    setGlobalError(
                        data.errorMessage
                            ? data.errorMessage
                            : DEFAULT_ERROR_MSG
                    )
                )
        ),
        Observable.of(fetchCalculationDataError(error))
    );

const callbackEpic = action$ =>
    action$
        .ofType(actionTypes.RECEIVE)
        .do(action => {
            if (action.callback) {
                action.callback();
            }
        })
        .ignoreElements();

export default [...epics, callbackEpic];
